import { cn } from '@/shared/utils/cn'

const GRADIENTS = [
  'from-[#ff6b35] to-[#e85a25]',
  'from-[#0d9488] to-[#0f766e]',
  'from-[#2563eb] to-[#1d4ed8]',
  'from-[#a855f7] to-[#7e22ce]',
  'from-[#dc2626] to-[#b91c1c]',
]

function pickGradient(seed: string): string {
  let hash = 0
  for (let i = 0; i < seed.length; i++) {
    hash = (hash * 31 + seed.charCodeAt(i)) >>> 0
  }
  return GRADIENTS[hash % GRADIENTS.length] ?? GRADIENTS[0]!
}

interface BusinessLogoMarkProps {
  id: string
  name: string
  logo?: string | null
  size?: 'sm' | 'md' | 'lg'
  className?: string
}

const SIZE_MAP = {
  sm: 'h-9 w-9 text-sm',
  md: 'h-11 w-11 text-base',
  lg: 'h-14 w-14 text-lg',
}

export function BusinessLogoMark({
  id,
  name,
  logo,
  size = 'md',
  className,
}: BusinessLogoMarkProps) {
  if (logo) {
    return (
      <img
        src={logo}
        alt={name}
        className={cn('rounded-full object-cover', SIZE_MAP[size], className)}
      />
    )
  }

  const initial = name?.[0]?.toUpperCase() ?? '?'
  const gradient = pickGradient(id || name)

  return (
    <div
      className={cn(
        'flex items-center justify-center rounded-full bg-gradient-to-br font-semibold text-white shadow-sm',
        gradient,
        SIZE_MAP[size],
        className,
      )}
      aria-hidden="true"
    >
      {initial}
    </div>
  )
}
